import { render, staticRenderFns } from "./onChainManage.vue?vue&type=template&id=dee20492&scoped=true&"
import script from "./onChainManage.vue?vue&type=script&lang=js&"
export * from "./onChainManage.vue?vue&type=script&lang=js&"
import style0 from "./onChainManage.vue?vue&type=style&index=0&id=dee20492&prod&lang=scss&scoped=true&"
import style1 from "./onChainManage.vue?vue&type=style&index=1&id=dee20492&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee20492",
  null
  
)

export default component.exports